
const TokenKey = 'jpt-Token'
const UserInfoKey = 'userInfo'

export function getToken () {
  return window.sessionStorage.getItem(TokenKey)
}

export function setToken (token) {
  return window.sessionStorage.setItem(TokenKey, token)
}

export function removeToken () {
  return window.sessionStorage.removeItem(TokenKey)
}

export function setUserInfo (userInfo) {
  return window.localStorage.setItem(UserInfoKey, JSON.stringify(userInfo))
}

export function getUserInfo () {
  var userInfo = window.localStorage.getItem(UserInfoKey)
  return JSON.parse(userInfo)
}



// WEBPACK FOOTER //
// ./src/store/getToken.js